import { useState } from "react";
import { ArchiveIcon } from "lucide-react";
import { IconRender } from "@/components/shared/Icon-render";
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { EmailInboxDialog } from "@/pages/email-inbox/preview/email-inbox-dialog";

export const EmailSource = ({ archiveId }: { archiveId?: string }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);

  const icon = (
    <IconRender
      name="Mail"
      size={15}
      strokeWidth={1.5}
      className=" text-primary"
    />
  );

  if (!archiveId) {
    return (
      <Tooltip>
        <TooltipTrigger>{icon}</TooltipTrigger>
        <TooltipContent>
          <TooltipArrow />
          Email
        </TooltipContent>
      </Tooltip>
    );
  }

  return (
    <>
      <Tooltip open={menuOpen} onOpenChange={setMenuOpen} delayDuration={0}>
        <TooltipTrigger>{icon}</TooltipTrigger>
        <TooltipContent
          side="right"
          className="p-1 bg-background text-foreground border shadow-md"
        >
          <button
            type="button"
            className="flex w-full items-center gap-2 rounded-sm px-2 py-1.5 text-sm hover:bg-accent"
            onClick={() => {
              setMenuOpen(false);
              setDialogOpen(true);
            }}
          >
            <ArchiveIcon size={15} className="text-primary" />
            View Details
          </button>
        </TooltipContent>
      </Tooltip>
      <EmailInboxDialog
        archiveId={archiveId}
        open={dialogOpen}
        onOpenChange={setDialogOpen}
      />
    </>
  );
};
